import React from "react";

function Gemini() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.159 496.159"
      enableBackground="new 0 0 496.159 496.159"
    >
      <path
        fill="#F9DC5F"
        d="M248.083,0.003C111.071,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.083,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.159,111.062,385.089,0.003,248.083,0.003z"
      />
      <path
        fill="#B97141"
        d="M213.286,276.657c27.443-36.322,25.022-81.523,25.022-81.523
	c-4.036-58.115-58.115-70.223-58.115-70.223C93.826,101.503,78.49,160.426,78.49,160.426
	c-19.372,20.179-12.915,63.765-12.915,63.765c-0.807,10.089-21.995,34.103-21.995,34.103c-4.439,5.449,0.807,9.888,0.807,9.888
	c3.027,2.825,11.301,3.833,11.301,3.833c1.21,0.808,1.009,2.826,1.009,2.826l-2.422,8.878c-0.605,3.431,4.641,7.668,4.641,7.668
	c0.808,1.614-0.605,3.229-0.605,3.229c-2.018,3.026-2.421,5.448-2.421,5.448c-0.808,4.036,5.65,9.687,5.65,9.687
	c0.807,4.035-4.843,12.914-4.843,12.914c-1.615,13.318,9.686,13.722,9.686,13.722h34.708l18.564,40.358l94.438-29.058
	C198.757,321.858,213.286,276.657,213.286,276.657z"
      />
      <polygon
        fill="#A55D35"
        points="151.538,306.925 66.383,336.386 101.091,336.386 153.152,309.347 153.556,297.642 "
      />
      <path
        fill="#70462A"
        d="M238.308,195.134c-4.036-58.115-58.115-70.223-58.115-70.223
	C93.826,101.503,78.49,160.426,78.49,160.426c62.958,4.843,65.172,61.318,89.999,107.755c18.118,33.891,38.522,51.973,38.579,47.219
	c0.242-20.151,6.218-38.744,6.218-38.744C240.729,240.334,238.308,195.134,238.308,195.134z"
      />
      <g>
        <path
          fill="#A55D35"
          d="M174.824,222.093c-17.687-4.708-19.981,20.099-19.981,20.099l-0.346,25.725
		c4.906,4.321,10.361,5.73,13.602,0.926c5.116-7.588,12.499-18.418,17.879-27.7C193.009,229.011,181.258,223.807,174.824,222.093z"
        />
        <path
          fill="#A55D35"
          d="M66.113,263.743c-1.346,9.416-9.416,8.071-9.416,8.071l4.305,1.346
		C69.344,272.621,66.113,263.743,66.113,263.743z"
        />
        <path
          fill="#A55D35"
          d="M70.823,224.998c0,0,8.071,7.265,23.003-2.422C93.826,222.577,82.93,226.209,70.823,224.998z"
        />
      </g>
      <path
        fill="#70462A"
        d="M95.643,201.793c-5.65-2.422-29.058-1.614-29.058-1.614c-2.152,3.296,0.771,6.659,2.219,6.659
	c20.853,0,33.901,5.65,33.901,5.65C102.1,204.416,95.643,201.793,95.643,201.793z"
      />
      <g>
        <path
          fill="#B97141"
          d="M177.233,210.604c-20.717-5.516-23.408,23.542-23.408,23.542l-0.404,30.133
		c5.746,5.063,12.136,6.714,15.932,1.086c5.995-8.888,11.375-16.421,17.497-25.839C195.803,225.757,184.77,212.611,177.233,210.604z
		"
        />
        <path
          fill="#B97141"
          d="M452.579,258.294c0,0-21.188-24.013-21.995-34.103c0,0,6.457-43.586-12.915-63.765
		c0,0-15.336-58.923-101.702-35.515c0,0-54.079,12.107-58.115,70.223c0,0-2.421,45.201,25.022,81.523c0,0,14.528,45.201-0.807,71.03
		l94.438,29.058l18.564-40.358h34.708c0,0,11.301-0.403,9.686-13.722c0,0-5.65-8.879-4.843-12.914c0,0,6.458-5.65,5.65-9.687
		c0,0-0.403-2.421-2.421-5.448c0,0-1.413-1.615-0.605-3.229c0,0,5.247-4.238,4.641-7.668l-2.422-8.878c0,0-0.202-2.018,1.009-2.826
		c0,0,8.273-1.008,11.301-3.833C451.772,268.182,457.018,263.743,452.579,258.294z"
        />
      </g>
      <polygon
        fill="#A55D35"
        points="344.622,306.925 342.604,297.642 343.008,309.347 395.069,336.386 429.777,336.386 "
      />
      <path
        fill="#70462A"
        d="M315.968,124.911c0,0-54.079,12.107-58.115,70.223c0,0-2.421,45.201,25.022,81.523
	c0,0,5.976,18.593,6.218,38.744c0.057,4.754,20.461-13.328,38.579-47.219c24.827-46.437,27.04-102.913,89.999-107.755
	C417.67,160.426,402.334,101.503,315.968,124.911z"
      />
      <g>
        <path
          fill="#A55D35"
          d="M341.317,242.192c0,0-2.295-24.807-19.981-20.099c-6.434,1.713-18.185,6.918-11.154,19.049
		c5.38,9.282,12.763,20.112,17.879,27.7c3.241,4.805,8.696,3.395,13.602-0.926L341.317,242.192z"
        />
        <path
          fill="#A55D35"
          d="M430.047,263.743c0,0-3.23,8.878,5.111,9.417l4.305-1.346
		C439.463,271.814,431.393,273.159,430.047,263.743z"
        />
        <path
          fill="#A55D35"
          d="M402.334,222.577c14.932,9.687,23.003,2.422,23.003,2.422
		C413.23,226.209,402.334,222.577,402.334,222.577z"
        />
      </g>
      <path
        fill="#70462A"
        d="M429.575,200.179c0,0-23.408-0.808-29.058,1.614c0,0-6.457,2.623-7.063,10.695
	c0,0,13.048-5.65,33.901-5.65C428.804,206.838,431.727,203.475,429.575,200.179z"
      />
      <path
        fill="#B97141"
        d="M342.334,234.147c0,0-2.691-29.058-23.408-23.542c-7.537,2.007-18.569,15.152-9.618,28.923
	c6.122,9.417,11.502,16.951,17.497,25.839c3.796,5.628,10.186,3.977,15.932-1.086L342.334,234.147z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Gemini;
